/**
 * Rollgerüst Welt – CRO-Anpassungen
 *
 * 1. Artikelnummer per Klick in die Zwischenablage kopieren
 * 2. <range-facet>: Von/Bis-Regler für numerische Metafeld-Filter
 */

(function () {
  "use strict";

  /* ----------------------------------------------------------------
   * 1. Artikelnummer kopieren
   * ---------------------------------------------------------------- */

  var COPY_FEEDBACK_MS = 1500;

  function canCopy() {
    return !!(navigator.clipboard && navigator.clipboard.writeText);
  }

  // Ohne Zwischenablage-Zugriff (z. B. unsicherer Kontext) wäre der Chip ein
  // Button, der nichts tut. Dann lieber als reine Anzeige kennzeichnen.
  function markStaticChips() {
    if (canCopy()) {
      return;
    }

    document.querySelectorAll("[data-rgw-copy-sku]").forEach(function (chip) {
      chip.classList.add("rgw-sku-chip-static");
    });
  }

  function copySku(chip) {
    var valueNode = chip.querySelector(".rgw-sku-chip-value");
    var sku = valueNode ? valueNode.textContent.trim() : "";

    if (!sku || !canCopy()) {
      return;
    }

    navigator.clipboard.writeText(sku).then(
      function () {
        var feedback = chip.querySelector("[data-rgw-copy-feedback]");

        chip.classList.add("is-copied");
        if (feedback) {
          feedback.textContent = window.rgwStrings ? window.rgwStrings.skuCopied : "";
        }

        window.clearTimeout(chip.rgwCopyTimer);
        chip.rgwCopyTimer = window.setTimeout(function () {
          chip.classList.remove("is-copied");
          if (feedback) {
            feedback.textContent = "";
          }
        }, COPY_FEEDBACK_MS);
      },
      function () {
        /* Verweigerte Zwischenablage: keine Rückmeldung, aber auch kein Fehler */
      },
    );
  }

  document.addEventListener("click", function (event) {
    var chip = event.target.closest("[data-rgw-copy-sku]");

    if (!chip || chip.classList.contains("rgw-sku-chip-static")) {
      return;
    }

    copySku(chip);
  });

  // Das Skript laeuft mit defer, der DOM steht also in aller Regel schon.
  // Der zusaetzliche Listener greift nur, falls es doch frueher ausgefuehrt wird.
  markStaticChips();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", markStaticChips);
  }

  // Nach einem Variantenwechsel tauscht das Theme Blöcke aus
  document.addEventListener("product:variant-change", markStaticChips);

  /* ----------------------------------------------------------------
   * 2. Von/Bis-Regler für Metafeld-Filter
   * ----------------------------------------------------------------
   *
   * Shopify kennt für Metafeld-Filter nur den Typ 'list' (Mehrfachauswahl per
   * Checkbox), kein natives Von/Bis. Der Regler ist deshalb reine Frontend-
   * Übersetzung: Er hakt alle Checkboxen innerhalb der gewählten Spanne an und
   * überlässt das eigentliche Filtern dem Theme – FacetFiltersForm sammelt beim
   * input-Event ohnehin das komplette Formular ein und lädt die Sektion per AJAX
   * nach. Dadurch bleiben URL, aktive Filter und Verlauf ohne Zusatzcode intakt.
   */

  function formatNumber(value) {
    return value.toLocaleString("de-DE", { maximumFractionDigits: 2 });
  }

  class RangeFacet extends HTMLElement {
    connectedCallback() {
      this.unit = this.dataset.unit || "";
      this.items = this.collectItems();

      // Unter drei Werten ist ein Regler sinnlos, dann bleibt die Liste stehen
      if (this.items.length < 3) {
        return;
      }

      this.build();
    }

    /**
     * Die echten Filter-Checkboxen, numerisch sortiert. Shopify sortiert
     * Filterwerte als Text, dort landet "9.5" hinter "49.4".
     */
    collectItems() {
      var nodes = Array.prototype.slice.call(
        this.querySelectorAll('.rgw-range-inputs input[type="checkbox"]'),
      );

      return nodes
        .map(function (input) {
          return { input: input, value: parseFloat(input.value) };
        })
        .filter(function (item) {
          return !isNaN(item.value);
        })
        .sort(function (a, b) {
          return a.value - b.value;
        });
    }

    build() {
      var last = this.items.length - 1;
      var checked = this.items
        .map(function (item, index) {
          return item.input.checked ? index : -1;
        })
        .filter(function (index) {
          return index > -1;
        });

      var lo = checked.length ? Math.min.apply(null, checked) : 0;
      var hi = checked.length ? Math.max.apply(null, checked) : last;

      this.readout = document.createElement("span");
      this.readout.className = "rgw-range-readout";

      var track = document.createElement("div");
      track.className = "rgw-range-track";

      var rail = document.createElement("span");
      rail.className = "rgw-range-rail";

      this.fill = document.createElement("span");
      this.fill.className = "rgw-range-fill";

      this.minInput = this.createInput(last, lo, "Von");
      this.maxInput = this.createInput(last, hi, "Bis");

      track.appendChild(rail);
      track.appendChild(this.fill);
      track.appendChild(this.minInput);
      track.appendChild(this.maxInput);

      var scale = document.createElement("div");
      scale.className = "rgw-range-scale";
      scale.innerHTML =
        "<span>" +
        this.label(0) +
        "</span><span>" +
        this.label(last) +
        "</span>";

      var wrapper = document.createElement("div");
      wrapper.className = "rgw-range";
      wrapper.appendChild(this.readout);
      wrapper.appendChild(track);
      wrapper.appendChild(scale);

      this.insertBefore(wrapper, this.firstChild);
      this.render();
    }

    createInput(max, value, labelText) {
      var input = document.createElement("input");

      input.type = "range";
      input.className = "rgw-range-input";
      input.min = "0";
      input.max = String(max);
      input.step = "1";
      input.value = String(value);
      input.setAttribute("aria-label", labelText);

      // Nur die Anzeige folgt dem Ziehen, gefiltert wird erst beim Loslassen.
      //
      // stopPropagation ist hier zwingend, nicht kosmetisch: Das Theme hoert auf
      // input-Events innerhalb von .facet und laedt daraufhin die Facets per AJAX
      // neu. Ein Range-Input feuert beim Ziehen laufend input-Events, die nach
      // oben durchlaufen. Das Theme hat dann das Formular ausgelesen, BEVOR
      // apply() die Checkboxen gesetzt hat, also ohne diesen Filter. Die Section
      // wurde mit leerem Filter ersetzt und der Regler sprang auf den Anfang
      // zurueck, waehrend des Ziehens immer wieder.
      //
      // Gemessen am 01.10.2026 auf /collections/all: mit durchlaufendem Event
      // ging eine AJAX-Anfrage OHNE den Filter raus und der Regler stand danach
      // wieder auf 0 bis 98. Ohne das Durchlaufen enthielt die Anfrage den
      // Filter und der Regler blieb auf 30 bis 98 stehen.
      //
      // Der Filter wird weiterhin ausgeloest, nur eben kontrolliert: apply()
      // feuert selbst ein input-Event auf einer Checkbox, und DAS darf und soll
      // durchlaufen.
      var self = this;

      input.addEventListener("input", function (event) {
        event.stopPropagation();
        self.onInput();
      });

      input.addEventListener("change", function (event) {
        event.stopPropagation();
        self.onChange();
      });

      return input;
    }

    onInput() {
      var lo = parseInt(this.minInput.value, 10);
      var hi = parseInt(this.maxInput.value, 10);

      // Griffe dürfen sich nicht überholen
      if (lo > hi) {
        if (document.activeElement === this.minInput) {
          this.maxInput.value = String(lo);
        } else {
          this.minInput.value = String(hi);
        }
      }

      this.render();
    }

    onChange() {
      this.onInput();
      this.apply();
    }

    render() {
      var lo = parseInt(this.minInput.value, 10);
      var hi = parseInt(this.maxInput.value, 10);
      var last = this.items.length - 1;

      this.readout.textContent =
        lo === hi ? this.label(lo) : this.label(lo) + " – " + this.label(hi);

      var left = (lo / last) * 100;
      var right = (hi / last) * 100;
      this.fill.style.left = left + "%";
      this.fill.style.width = right - left + "%";

      // Am oberen Anschlag liegen beide Griffe übereinander; der untere muss
      // dann obenauf liegen, sonst lässt er sich nicht mehr greifen.
      this.minInput.style.zIndex = lo === last ? "3" : "1";
      this.maxInput.style.zIndex = lo === last ? "1" : "2";
    }

    label(index) {
      var value = formatNumber(this.items[index].value);

      return this.unit ? value + " " + this.unit : value;
    }

    /**
     * Spanne auf die echten Checkboxen übertragen. Deckt die Spanne den
     * kompletten Wertebereich ab, wird gar nicht gefiltert – sonst stünde ein
     * Filter in der URL, der nichts einschränkt.
     */
    apply() {
      var lo = parseInt(this.minInput.value, 10);
      var hi = parseInt(this.maxInput.value, 10);
      var isFullRange = lo === 0 && hi === this.items.length - 1;
      var changed = null;

      this.items.forEach(function (item, index) {
        var shouldBeChecked = !isFullRange && index >= lo && index <= hi;

        if (item.input.checked !== shouldBeChecked) {
          item.input.checked = shouldBeChecked;
          changed = item.input;
        }
      });

      if (!changed) {
        return;
      }

      // Das Theme hört auf input-Events innerhalb von .facet und liest dann das
      // gesamte Formular aus – ein einzelnes Event genügt für alle Änderungen.
      changed.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }

  if (!customElements.get("range-facet")) {
    customElements.define("range-facet", RangeFacet);
  }
})();
